import { render, staticRenderFns } from "./DialogExtraWork.vue?vue&type=template&id=35ab6da4"
import script from "./DialogExtraWork.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogExtraWork.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports